import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {flex, mb, w100} from "@pg-design/helpers-css";
import {Radio} from "@pg-design/radio-module";

import {FilterFooter} from "../../../search/components/filters/SearchFiltersFooter";
import {SearchSortString} from "../constants/SearchSort";
import {useOfferListSort} from "../hooks/useOfferListSort";

export interface IOfferListSort {
    name: string;
    onSubmit: () => void;
    latestQuerySort?: SearchSortString;
    onMobileResetForm: () => void;
}

const options = [
    {
        title: "Polecane",
        value: SearchSortString.DEFAULT
    },
    {
        title: "Najnowsze",
        value: SearchSortString.LATEST
    },
    {
        title: "Najtańsze",
        value: SearchSortString.PRICE
    },
    {
        title: "Najtańsze (za m2)",
        value: SearchSortString.PRICE_M2
    },
    {
        title: "Termin oddania",
        value: SearchSortString.CONSTRUCTION_DATE
    }
];

// TODO: This component could be merged with `OfferListSort` - but we have limited time during rebranding
export const OfferListSortMobile: React.FC<IOfferListSort> = (props) => {
    const {currentActive, setCurrentActive, sortHandler} = useOfferListSort({
        latestQuerySort: props.latestQuerySort,
        onSubmit: props.onSubmit || (() => null)
    });
    const onSave = () => {
        sortHandler(currentActive);
    };

    return (
        <SortWrapper>
            <div>
                {options.map((option) => {
                    return (
                        <div key={option.value} css={mb(3)}>
                            <Radio
                                id={option.title}
                                name={option.title}
                                isActive={currentActive === option.value}
                                value={option.value}
                                labelContent={option.title}
                                onChange={(_name: string, _isActive: boolean, value: string | number | boolean) => setCurrentActive(value as SearchSortString)}
                            />
                        </div>
                    );
                })}
            </div>

            <div css={filtersFooterWrapper}>
                <FilterFooter onCancel={props.onMobileResetForm} onSave={onSave} />
            </div>
        </SortWrapper>
    );
};

const SortWrapper = styled.div`
    width: 100%;
    padding: 2.4rem 1.2rem 3.2rem 2.4rem;
    ${flex("normal", "space-between")};
    flex-direction: column;
    min-height: calc(100vh - 46px); // minus modal header height

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        padding-top: unset;
        background: #f9f9f9;
    }
`;

const filtersFooterWrapper = css`
    ${w100};
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 0 1.2rem;
`;
import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {flex, mb, w100} from "@pg-design/helpers-css";
import {Radio} from "@pg-design/radio-module";

import {FilterFooter} from "../../../search/components/filters/SearchFiltersFooter";
import {SearchSortString} from "../constants/SearchSort";
import {useOfferListSort} from "../hooks/useOfferListSort";

export interface IOfferListSort {
    name: string;
    onSubmit: () => void;
    latestQuerySort?: SearchSortString;
    onMobileResetForm: () => void;
}

const options = [
    {
        title: "Polecane",
        value: SearchSortString.DEFAULT
    },
    {
        title: "Najnowsze",
        value: SearchSortString.LATEST
    },
    {
        title: "Najtańsze",
        value: SearchSortString.PRICE
    },
    {
        title: "Najtańsze (za m2)",
        value: SearchSortString.PRICE_M2
    },
    {
        title: "Termin oddania",
        value: SearchSortString.CONSTRUCTION_DATE
    }
];

// TODO: This component could be merged with `OfferListSort` - but we have limited time during rebranding
export const OfferListSortMobile: React.FC<IOfferListSort> = (props) => {
    const {currentActive, setCurrentActive, sortHandler} = useOfferListSort({
        latestQuerySort: props.latestQuerySort,
        onSubmit: props.onSubmit || (() => null)
    });
    const onSave = () => {
        sortHandler(currentActive);
    };

    return (
        <SortWrapper>
            <div>
                {options.map((option) => {
                    return (
                        <div key={option.value} css={mb(3)}>
                            <Radio
                                id={option.title}
                                name={option.title}
                                isActive={currentActive === option.value}
                                value={option.value}
                                labelContent={option.title}
                                onChange={(_name: string, _isActive: boolean, value: string | number | boolean) => setCurrentActive(value as SearchSortString)}
                            />
                        </div>
                    );
                })}
            </div>

            <div css={filtersFooterWrapper}>
                <FilterFooter onCancel={props.onMobileResetForm} onSave={onSave} />
            </div>
        </SortWrapper>
    );
};

const SortWrapper = styled.div`
    width: 100%;
    padding: 2.4rem 1.2rem 3.2rem 2.4rem;
    ${flex("normal", "space-between")};
    flex-direction: column;
    min-height: calc(100vh - 46px); // minus modal header height

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        padding-top: unset;
        background: #f9f9f9;
    }
`;

const filtersFooterWrapper = css`
    ${w100};
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 0 1.2rem;
`;
